import {
  String,
  And,
  Or,
  Not,
  To,
  Near,
  Next,
  //Date_format
} from "./solr-parser.terms.js";

const keywordTokens = {
  string: String,
  and: And,
  or: Or,
  not: Not,
  to: To,
  near: Near,
  next: Next,
  //date_format: Date_format
};
export const specializeIdentifier = (value, stack) => {
  return keywordTokens[value.toLowerCase()] || -1;
};
